let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("h3GJZ")).then(() => parcelRequire('jouXW'));